const spoofedEvents = (target) => ({
  stopPropagation () {},
  preventDefault () {},
  target
})

export default spoofedEvents
